import React, { useState } from 'react';
import { Account } from '../components/Accounts';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import InfoSectionRouter from '../components/InfoSectionRouter';
import {
  homeObjThree
} from '../components/InfoSection/Data';
import {
  homeObjOne, analysisInfoSection, performanceInfoSection,
  // homeObjThree
} from '../components/InfoSectionRouter/RouterData';
// import CoinTable from '../components/CoinBuildForms/CoinPage';
// import Services from '../components/Services';

function Home() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Account>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection />
      <InfoSectionRouter {...homeObjOne} />
      {/* <CoinTable /> */}
      <InfoSectionRouter {...analysisInfoSection} />
      <InfoSection {...homeObjThree} />
      <InfoSectionRouter {...performanceInfoSection} />
      <Footer />
    </Account>
  );
}

export default Home;
